import CategorySearch from 'marketing/components/CategorySearch';
import CategoriesView from 'marketing/components/CategoriesView';
import CategoriesScrollBehaviour from 'marketing/components/CategoriesScrollBehaviour';
import FullTextSearch from 'marketing/utils/FullTextSearch';
import { trackEvent } from '@99designs/utils/platform';
import CategoryBrowseAccordion from 'marketing/components/CategoryBrowseAccordion';

document.addEventListener('DOMContentLoaded', () => {
    new CategoryBrowseAccordion();
    new CategoriesView(document.querySelector('[data-categories-view]'));
    new CategoriesScrollBehaviour();
    new CategorySearch(
        document.querySelector('[data-search-field]'),
        document.querySelector('[data-search-results-count]'),
        document.querySelector('[data-search-results]'),
        initializeSearcher()
    );

    initializeLinkTracking(document);
    initializeButtonTracking();
});

function initializeSearcher() {
    const searchConfig = [
        {name: 'title', weight: 0.8},
        {name: 'parent', weight: 0.4},
        {name: 'keywords', weight: 0.2},
    ]
    const searchdocuments = readCategoriesData();
    const fallBackResult = searchdocuments.filter((doc) => { return doc.key === 'other-design' }).pop();

    return new FullTextSearch(searchdocuments, searchConfig, fallBackResult);
}

function readCategoriesData() {
    const categories = [];

    window.categories.forEach((category) => {
        const categoryNode = document.querySelector(`[data-category-${category.key}]`);

        if (categoryNode) {
            const clone = categoryNode.cloneNode(true);
            initializeLinkTracking(clone);

            categories.push({
                title: category.title,
                parent: category.parent_category_title,
                keywords: category.keywords.join(' '),
                node: clone,
                key: category.key
            });
        }
    });

    return categories;
}

function initializeLinkTracking(element) {
    const categoryLinks = element.querySelectorAll('[data-category-link]');

    Array.from(categoryLinks).forEach((categoryLink) => {
        categoryLink.addEventListener('click', trackClickedLink);
    });
}

function initializeButtonTracking() {
    const enableBrowseModeButton = document.querySelector('[data-browse-all-button]');

    enableBrowseModeButton.addEventListener('click', ()  => {
        trackEvent('Clicked Enable Browse Button On Categories Page');
    });
}

function trackClickedLink(event) {
    const searchBox = document.querySelector('[data-search-field]');

    trackEvent('Clicked Link On Categories Page', {
        category: event.currentTarget.getAttribute('data-category-key'),
        searchTerm: searchBox ? searchBox.value : null
    });
}



// WEBPACK FOOTER //
// ./js/marketing/categories.js